import ApplicationStore from '../stores/ApplicationStore';
import DocumentStore from '../stores/DocumentStore';
import QuickstartStore from '../stores/QuickstartStore';
import UserStore from '../stores/UserStore';
import { CLIENT_ID as DEFAULT_CLIENT_ID } from '../../lib/helpers/defaults';
import metrics from '../browser/metrics';

const selectResource = (context, payload) => {
  const domainUrlDocs = context.getStore(ApplicationStore).getDomainUrlDocs();
  const fetchService = context.getService('FetchService');
  metrics.track('select:user_resource', payload);

  return fetchService(`${domainUrlDocs}/auth/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};

export function performSelectClient(context, payload) {
  const { selectedId } = payload;

  if (
    context.getStore(DocumentStore).getSelectedClientId() === selectedId &&
    context.getStore(UserStore).getSelectedClientId() === selectedId
  ) {
    return Promise.resolve();
  }

  context.dispatch('USER_CLIENTS_SELECTED', { selectedId });
  context.dispatch('DOCUMENT_CLIENTS_SELECTED', { selectedId });
  return selectResource(context, { selectedClientId: selectedId });
}

export function performSelectApi(context, payload) {
  const { selectedId } = payload;

  if (
    context.getStore(DocumentStore).getSelectedApiId() === selectedId &&
    context.getStore(UserStore).getSelectedApiId() === selectedId
  ) {
    return Promise.resolve();
  }

  context.dispatch('USER_APIS_SELECTED', { selectedId });
  context.dispatch('DOCUMENT_APIS_SELECTED', { selectedId });
  return selectResource(context, { selectedApiId: selectedId });
}

export function setSelectClientForTutorial(context, isFramedMode) {
  if (isFramedMode) {
    // Framed mode will provide selected client
    return Promise.resolve();
  }

  const userStore = context.getStore(UserStore);

  if (!userStore.isAuthenticated()) {
    // No need to select application for non-authenticated users
    return Promise.resolve();
  }

  const quickstartType = context.getStore(QuickstartStore).getQuickstartType();

  const compatibleClients = userStore.getQuickstartCompatibleClients(quickstartType);
  if (compatibleClients.find((c) => c.client_id === userStore.getSelectedClientId())) {
    // Client is compatible, no need to select new one
    return Promise.resolve();
  }

  const newClient = compatibleClients[0];
  const selectedId = newClient ? newClient.client_id : DEFAULT_CLIENT_ID;

  return performSelectClient(context, { selectedId });
}
